export const tocHelper = () => {
    // Remove links to non-existing blocks from the TOC.
    // Blocks which are empty may be not shown.
    const tocLinks = document.getElementsByClassName('arl-toc__link');

    if (!tocLinks) {
        return;
    }

    for (const tocLink of tocLinks) {
        const targetElement = document.getElementById(
            tocLink.hash.replace('#', '')
        );

        if (!targetElement) {
            tocLink.parentElement.style.display = 'none';
        }
    }
};
